import Splide, { EventInterface } from "@splidejs/splide";
import "@splidejs/splide/css";

export const initSlideshows = () => {
	if (document.querySelector(".hero-slider")) {
		new Splide(".hero-slider", {
			direction: "ttb",
			autoplay: true,
			arrows: false,
			pagination: false,
			height: "500px",
			type: "loop",
			breakpoints: {
				1280: {
					height: "500px",
				},

				768: {
					height: "350px",
				},

				400: {
					height: "250px",
				},
			},
		}).mount();
	}

	if (document.querySelector(".testimonial-slider")) {
		new Splide(".testimonial-slider", {
			type: "loop",
			autoplay: true,
			// heightRatio: 0.5,
			interval: 8000,
			pagination: true,
			arrows: false,
			drag: false,
			768: {
				arrows: true,
			},
		}).mount({}, MyTransition);
	}

	if (document.querySelector(".solutions-layout.strip")) {
		new Splide(".solutions-layout.strip", {
			gap: "10px",
			perPage: 7,
			breakpoints: {
				1280: {
					arrows: true,
					pagination: true,
				},
				1024: {
					perPage: 5,
				},
				768: {
					perPage: 2,
				},
				500: {
					type: "loop",
					perPage: 1,
					arrows: true,
					padding: "4rem",
					focus: "center",
				},
			},
		}).mount();
	}

	if (document.querySelector(".logo-strip")) {
		new Splide(".logo-strip", {
			type: "loop",
			autoplay: true,
			pauseOnHover: false,
			gap: "0.25em",
			perPage: 5,
			arrows: false,
			pagination: false,
			breakpoints: {
				1024: {
					perPage: 4,
				},
				768: {
					perPage: 3,
				},
				500: {
					perPage: 2,
				},
			},
		}).mount();
	}
};

export function MyTransition(Splide, Components) {
	const { bind } = EventInterface(Splide);
	const { Move } = Components;
	const { list, slides } = Components.Elements;
	let endCallback;

	function mount() {
		bind(list, "transitionend", (event) => {
			if (event.target === list && endCallback) {
				// Transition has ended
				cancel(); // Clear the transition
				endCallback(); // Complete the transition
			}
		});
	}

	function start(index, done) {
		// The `done` callback should be called when the transition completes
		endCallback = done;

		// Retrieve the destination from the Move component
		const destination = Move.toPosition(index, true);

		// Apply your custom transition styles here
		slides.forEach((slide, i) => {
			// const slideElement = slide.slide;
			const slideElement = slide;

			// Reset all slides
			slideElement.style.opacity = "0";
			// slideElement.style.transform = "translateY(100%)";
			slideElement.style.transition = "";
		});

		// Apply the transition to the next slide
		const nextSlide = slides[index];
		if (nextSlide) {
			// const nextSlideElement = nextSlide.slide;
			const nextSlideElement = nextSlide;

			// Apply transition properties to the next slide only
			nextSlideElement.style.opacity = "1";
			// nextSlideElement.style.transform = "translateY(0)";
			nextSlideElement.style.transition = "transform 100ms, opacity 100ms";
		}

		// Start the transition by moving the list
		list.style.transition = "transform 100ms cubic-bezier(.44,.65,.07,1.01)";
		Move.translate(destination);
	}

	function cancel() {
		list.style.transition = "";
		slides.forEach((slide) => {
			// const slideElement = slide.slide;
			const slideElement = slide;
			slideElement.style.opacity = "";
			slideElement.style.transform = "";
			slideElement.style.transition = "";
		});
	}

	return {
		mount,
		start,
		cancel,
	};
}
